import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import "./styles.scss";

const InitialLoader = ({ isVisible }) => {
	const shouldReduceMotion = useReducedMotion();

	return (
		<AnimatePresence>
			{isVisible ? (
				<motion.div
					className="initial-loader"
					initial={shouldReduceMotion ? false : { opacity: 1 }}
					animate={{ opacity: 1 }}
					exit={shouldReduceMotion ? { opacity: 0 } : { opacity: 0, scale: 0.98 }}
					transition={{ duration: 0.35, ease: "easeOut" }}
				>
					<motion.img
						src="/images/logo-p-blanco.png"
						alt="ForzaKargo"
						initial={shouldReduceMotion ? false : { opacity: 0, y: 8 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.35, ease: "easeOut" }}
					/>
					<div className="loader_bar">
						<span />
					</div>
				</motion.div>
			) : null}
		</AnimatePresence>
	);
};

export default InitialLoader;
